import CatalogMenuItem from "./CatalogMenuItem";
import {TopCategoryInterface} from "../../../interfaces/catalog/TopCategoryInterface";
import {Link} from "react-router-dom";

export default function CatalogMenu({categories, newCategories, closeMenu}: {categories: TopCategoryInterface[], newCategories: TopCategoryInterface[], closeMenu: () =>  void})
{
    return (<div className="header__mob-menu mob-menu your-menu menu-catalog" onClick={closeMenu}>
        <div className="container" >
            <div className="d-flex flex-column mob-menu__body" onClick={(e) => e.stopPropagation()}>
                <div className="icon-menu icon-menu-catalog mob-menu__close" onClick={closeMenu}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 17L1 1M17 1L1 17" stroke="#292929" strokeWidth="0.625"
                              stroke-linecap="round"/>
                    </svg>
                </div>

                <div className="d-flex align-items-center justify-content-center mob-menu__head _two">
                    <span className="fw-bold">Каталог</span>
                </div>
                <div className="d-flex flex-column mob-menu__list-row">
                    <ul className="d-flex flex-column mob-menu__list p-0">
                        {newCategories.length > 0 && <CatalogMenuItem name={'Новинки'} className="t-orange fw-bold"
                                                                      items={newCategories.map(item => item.category)} basePath={'/catalog/new'}>
                            <li><Link to={'/catalog/new'} className="mob-menu__link" onClick={closeMenu}>Все новинки</Link></li>
                        </CatalogMenuItem>}
                        {categories.map(categoryItem => <CatalogMenuItem key={categoryItem.category.catalog_code} name={categoryItem.category.name} items={categoryItem.items} />)}
                    </ul>
                </div>

            </div>
        </div>

    </div>)
}